import axios from "./AxiosService";

export default function SystemUnavailabilityService() {
  return axios.get("SystemAvailability", {
    avoidLoadingFeature: true,
    avoidSilentRenew: true
  });
}
